<template>
  <md-card class="contract-type-selection-card">
        <md-card-header>
            <div class="md-layout">
                <div class="md-layout-item md-title md-size-75">{{i18n_local.select_contract_type}}</div>
                <div class="md-layout-item md-size-25 text-right">
                    <md-button class="md-icon-button md-dense" @click="onClosed">
                        <md-icon>highlight_off</md-icon>
                    </md-button>
                </div>
            </div>
        </md-card-header>
        <md-card-content>
          <b-row class="text-center justify-content-center">
            <!-- SKIP -->
            <b-col cols="3" class="">
              <md-button
                class="md-button play-cta-button-flat makeup"
                @click="manualContractChosen"
              >{{i18n_local.skip_contract_selection}}</md-button>
            </b-col>

            <!-- ACCOMODATION AGREEMENT -->
            <b-col cols="4" class="contract-option cancel-opaque-on-hover" :class="{'opaque': selectedTemplateId || !shortBookingPeriod}">
                <p class="moow-info-txt"><strong>{{i18n_local.or_continue_w_tc}}</strong></p>
                <div v-if="shortBookingPeriod">
                  <p class="moow-info-txt secondary">{{i18n_local.info.choose_contract_tc}}</p>
                  <md-checkbox
                    v-model="termsAndConditionsSelected"
                    @change="handleTermsAndConditionsDialog"
                    class="md-primary"
                  >{{i18n_local.accept_terms}}</md-checkbox>
                  <br>
                  <md-button
                    :class="{ 'makeup': termsAndConditionsSelected, 'disabled': !termsAndConditionsSelected || selectedTemplateId }"
                    class="md-button play-cta-button"
                    :disabled="!contractTypeChosen || !termsAndConditionsSelected"
                    @click="onTypeChosen"
                  >NEXT</md-button>
                </div>
                <p v-else>{{i18n_local.info.tc_not_allowed}}</p>
            </b-col>
            
            <!-- FULL CONTRACT AGREEMENT -->
            <b-col cols="4" class="contract-option cancel-opaque-on-hover" :class="{'opaque': termsAndConditionsSelected || !allowContractTemplates}">
              <p class="moow-info-txt"><strong>{{i18n_local.choose_template}}</strong></p>
              <p class="moow-info-txt secondary">{{i18n_local.info.choose_contract_template}}</p>
              <!-- <info-toggle :infoContent="" size="small" /> -->
              <b-row class="md-layout md-alignment-center-center" v-if="requestPending">
                <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
              </b-row>
              <b-row v-else>
                <b-col>
                  <div class="md-layout-item md-size-100" >
                    <div v-if="!templates.length">
                      <p>No templates available</p>
                      <a class="mt-5" @click="addMoreTemplates()">Want to add your own template?</a>
                    </div>
                  </div>
                  <div v-if="templates.length && allowContractTemplates">
                    <div
                      v-for="template in templates"
                      :key="template.id"
                      class="md-layout-item md-size-100"
                    >
                      <md-radio
                        :value="template.id"
                        v-model="selectedTemplateId"
                        class="md-primary"
                        :disabled="!allowContractTemplates"
                      >
                        {{ template.name }} ({{ template.locale }})
                        <br />
                        <small>{{ template | templateDescription }}</small>
                      </md-radio>
                    </div>
                  </div>
                  <p v-if="!allowContractTemplates" style="color:red">Automatic contracts are not available for manually added or contracts with daily pricing.</p>
                  
                </b-col>
              </b-row>
              <md-button
                v-if="allowContractTemplates"
                :class="{ 'makeup': selectedTemplateId, 'disabled': termsAndConditionsSelected || !selectedTemplateId }"
                class="md-button play-cta-button"
                :disabled="termsAndConditionsSelected || !selectedTemplateId"
                @click="onTypeChosen"
              >NEXT</md-button>
            </b-col>
          </b-row>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-button" @click="onClosed">Cancel</md-button>
        </md-card-actions>
        <md-dialog :md-active="termsAndConditionsDialogOpened">
          <terms-and-conditions-dialog
            termsType="accomodation"
            :params="params"
            @makeDecision="onTermsAndConditionsDialogClosed"
            :requireBottom="false"
          ></terms-and-conditions-dialog>
        </md-dialog>
    </md-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import TermsAndConditionsDialog from "@/components/dialogs/TermsAndConditions.vue";
import InfoToggle from "@/components/interface/buttons/infoToggle.vue";

export default {
  name: "ContractTypeSelectionDialog",
  components: { TermsAndConditionsDialog, InfoToggle },
  props: {
    accountId: {
      type: String | Number,
      default: ""
    },
    shortBookingPeriod: {
      type: Boolean,
      default: false,
    },
    allowContractTemplates: {
      type: Boolean,
      default: false,
    },
    legalParams: {
      type: Object,
      required: false
    }
  },
  created() {
    if (Array.isArray(this.templates) && this.templates.length) {
      return;
    }
    this.getTemplates(this.accountId);
  },
  data() {
    return {
      manualContractSelected: false,
      termsAndConditionsSelected: false,
      termsAndConditionsDialogOpened: false,
      selectedTemplateId: "",
      params: this.legalParams
    };
  },
  watch: {
    selectedTemplateId: function(val) {
      if (val) this.termsAndConditionsSelected = false;
    }
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    ...mapState("contractTemplatesModule", ["templates", "requestPending"]),
    contractTypeChosen() {
      return this.termsAndConditionsSelected || this.selectedTemplateId;
    },
    contractType() {
      if (this.termsAndConditionsSelected) {
        return "tcAgreement";
      }
      if (this.selectedTemplateId) {
        return "contract";
      }
      if (this.manualContractSelected) {
        return "manual";
      }

      return null;
    }
  },
  methods: {
    ...mapActions("contractTemplatesModule", ["getTemplates"]),
    onClosed() {
      this.$emit("closed");
    },
    manualContractChosen() {
      this.manualContractSelected = true;
      this.onTypeChosen();
    },
    onTypeChosen() {
      if (!this.contractType) {
        return;
      }
      this.$emit("typeChosen", {
        type: this.contractType,
        templateId:
          this.contractType === "contract" ? this.selectedTemplateId : null
      });
      this.onClosed();
    },
    onTermsAndConditionsDialogClosed(decision) {
      if (!decision) {
        this.termsAndConditionsSelected = false;
      }
      this.termsAndConditionsDialogOpened = false;
    },
    handleTermsAndConditionsDialog(value) {
      const selected = Boolean(value);
      if (selected) {
        this.termsAndConditionsDialogOpened = true;
        this.selectedTemplateId = null;
      }
    },
    addMoreTemplates() {
      this.$emit("emitToggleSupportChat", true);
    }
  },
  filters: {
    templateDescription(template) {
      const templateType =
        template.type === "system" ? "Default template" : "Custom template";
      if (template.description) {
        return `${template.description}; ${templateType}`;
      }

      return `No description; ${templateType}`;
    }
  }
};
</script>

<style scoped>
@import "../../../assets/styles/global.css";
.contract-option{
  border: 1px solid;
  border-radius: 8px;
  margin-left: 1em;
  border-color: #F76765;
  padding-top: 1em;
}

.contract-type-selection-card {
  min-width: 600px;
}

.delimiter {
  width: 90%;
}
.opaque{
  opacity: .5;
}
</style>


// WEBPACK FOOTER //
// src/components/contracts/dialogs/ContractTypeSelectionDialog.vue